export const PlannerForecastType = {
  UploadedForecast: 'uploaded_forecast',
  StatisticalForecast: 'ds_forecast'
} as const

export type PlannerForecastTypeValue =
  (typeof PlannerForecastType)[keyof typeof PlannerForecastType]
